import React, {useEffect} from "react";
import {useAuth0} from "./providers/Auth0Provider";
import {navigate} from "@reach/router";
import {compose} from "redux";
import {connect} from "react-redux";

const PrivateRoute = ({ component: Component, path, uri, user, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();
  useEffect(() => {
    if (loading || isAuthenticated) {

      // if (isAuthenticated && user && !user.emailVerified) {
      //   navigate("/email-confirmation")
      // }

      return;
    }
    navigate("/login");
  }, [loading, isAuthenticated, loginWithRedirect, path, user]);

  return isAuthenticated ? <Component path={path} {...rest} /> : null;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    null
  )
)(PrivateRoute);